var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 12.8678V22.5H19.5262V14.6055C19.5262 13.2294 19.1203 12.1672 18.4537 11.451C17.7872 10.735 16.894 10.4034 16.005 10.4356C14.2083 10.5006 12.5199 12.0252 12.5199 14.6055V22.5H8.55876V7.50311H12.5584L12.5201 9.13793L13.4599 9.3872C14.3758 7.69087 16.8742 6.69102 19.2089 7.09337C20.3539 7.29069 21.4183 7.82237 22.1971 8.74009C22.9737 9.65521 23.5 10.994 23.5 12.8678ZM4.53673 2.55645C4.53646 3.10391 4.3218 3.6274 3.94227 4.01213C3.56299 4.39661 3.05029 4.6111 2.51736 4.61083C1.98443 4.61056 1.47193 4.39555 1.09302 4.01068C0.713868 3.62556 0.49973 3.10185 0.5 2.55438C0.50027 2.00692 0.714924 1.48343 1.09445 1.0987C1.47374 0.71422 1.98644 0.49973 2.51937 0.5C3.0523 0.500271 3.56479 0.715282 3.9437 1.10015C4.32286 1.48527 4.537 2.00898 4.53673 2.55645ZM0.575551 22.5V7.50311H4.61228V22.5H0.575551Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.803ffd2c75a915c9c34aff6e6cbde6f9.svg";
export { ForwardRef as ReactComponent };